// Booked trade values win by presence, including null; old request/DTO spellings remain readable.
const aliases = {
  strike_price: 'Strike', ko_price: 'ko_price', guarantee_periods: 'no_of_ko_periods',
  no_fixings: 'no_fixings', frequency: 'monthly_or_weekly', boosted_multiplier: 'multiplier2x',
  buffer_value: 'buffer_amount', spot_reference: 'spot_refernce', underlying: 'spot_refernce_ccy', direction: 'direction',
};
const objectValue = (value) => {
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch { return {}; }
  }
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
};
export const accumulatorParameters = (source) => {
  const economics = objectValue(source?.economics ?? source?.custom_accumulator);
  const dto = objectValue(source?.custom_ebtca_product ?? source?.customEbtcaProduct ?? source?.custom_product);
  const fields = objectValue(economics.fields);
  const parameters = {};
  Object.entries(aliases).forEach(([key, alias]) => {
    for (const [node, name] of [[fields, key], [fields, alias], [economics, key], [economics, alias], [dto, key], [dto, alias]]) {
      if (Object.prototype.hasOwnProperty.call(node, name)) { parameters[key] = node[name]; break; }
    }
  });
  return parameters;
};
export const normalizeAccumulatorOrder = (source) => {
  if (!['ACCUM', 'ACCUM_REV'].includes(source?.product?.product_type ?? source?.product_type)) return source;
  const parameters = accumulatorParameters(source);
  return { ...source, custom_ebtca_product: parameters,
    ...(Object.prototype.hasOwnProperty.call(parameters, 'strike_price') ? { strike_price: parameters.strike_price } : {}),
  };
};
